
$(document).ready( function() {
  
  var scroll = 0;
  var title_top = 0;
  
  $(window).scroll(function() {
    scroll = $(window).scrollTop();
    
    title_top = $(".product-single__title").offset().top;
    
    if (scroll >= (title_top - 50)) {
      $(".site-header").css('background', '#FFF');
    }
    else{
      $(".site-header").css('background', 'transparent');
    }
  });
  
  $('.qtybox .btnqty').on('click', function(){
    var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.quantity-input').val(qty);
  }); 
  
  $('.flexslider').flexslider({
    animation: "slide",
    after: function(slider){
      var currentSlide = slider.currentSlide;
      var slideshowProgressBarAdvancement = slider.next().find('.flexslider__progress-bar-advancement');

      if (slideshowProgressBarAdvancement.length > 0) {
        slideshowProgressBarAdvancement.css('width', ((currentSlide + 1) / slider.count * 100) + '%');
      }
    }
  });
  
  var slideshow = $(".flexslider");
  var slideshowProgressBarAdvancement = slideshow.nextAll('.flexslider__progress-bar').find('.flexslider__progress-bar-advancement');
  
  
    
  
//   var waitForEl = function(selector, callback) {
//     if (jQuery(selector).length) {
//       callback();
//     } else {
//       setTimeout(function() {
//         waitForEl(selector, callback);
//       }, 100);
//     }
//   };

//   waitForEl('.smart-tabs-navigation-links', function() {
//     $(".smart-tabs-navigation-li.smart-tabs-navigation-accordion:not(.smart-tabs-navigation-li-active)").trigger('click');
//   });
  
  $('.size-chart-open-popup').magnificPopup({
    type:'inline',
    midClick: true
  });
  
});


// Swatches
$(function() {
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });
});

$(window).load(function() { $('.selector-wrapper:eq({{ option_index }})').hide(); });

// End of Swatches Code

// Mobile Device menu open class add to homepage banner
$('button.site-header__menu').click(function(){
  if($('button.site-header__menu').hasClass('mobile-nav--close')){
    $('.banner_link').removeClass('changedPosition');
  }else{
    $('.banner_link').addClass('changedPosition');
  }
});

// Notify button text change on product page
setTimeout(function(){
  $('a#soon_stock').text('register your interest');
}, 0);

// Notify button text change on collection page
$(function() {
  if($('.template-collection .grid-view-item').hasClass('comingSoon')){
    $('.comingSoon').find('a.btn.klaviyo-bis-trigger').text('register your interest');
  }
});



// $(".ks-table-cell").hover(function(){
//    $(this).parent().siblings().find('.ks-table-col-hover').siblings().toggleClass('heyyou');
// });



 $(document).ready(function() {
  $(".ks-table-cell").hover(function(){
    $(this).parent().nextAll().toggleClass('removeBG');
    });
  });

var kiwiCell = $(".ks-table-cell")
console.log(kiwiCell, 'kiwiCell')

// Product Swatch Status

$(document).ready(function() {
  $(".template-product .swatch-element label").click(function() {
    // Add 'active' class to the corresponding stock status and remove it from siblings
    $(`.stock-status-text.${$(this).data("variant")}`).addClass("active");
    $(`.stock-status-text.${$(this).data("variant")}`).siblings().removeClass("active");

    if (!$(this).siblings("input").prop("checked")) {
      $(".price__sale").addClass("inactive");
    }
  });

  $(".BF-signup-form").hide();
  $(".signup-btn").on('click', function(){
    $(".BF-timer-section").hide();
    $(".BF-signup-form").show();
  });
});

                    